import httpClient from '../httpClient';

const getProjectsByStatus = async (status) => {
  return await httpClient.get(`forms_project_selector/projects/`, {
    params: { 'estado_proyecto': status },
  });
};

const getFormsByProject = async (project, idForm) => {
  return await httpClient.get(`forms/forms-by-project/`, {
    params: { project_id: project, idForm },
  });
};

const getCategories = async () => {
  return await httpClient.get(`forms_categories_selector/categories/`);
};

const retrieveForm = async (id) => {
  return await httpClient.get(`forms/${id}`);
}

const createForm = async (data) => {
  return await httpClient.post(`forms/`, data);
};

const updateForm = async (id, data) => {
  return await httpClient.put(`forms/${id}/`, data);
};

const deleteForm = async (id) => {
  return await httpClient.delete(`forms/${id}/`);
};

const deactivateForm = async (id) => {
  return await httpClient.patch(`forms/${id}/deactivate/`);
};

const activateForm = async (id) => {
  return await httpClient.patch(`forms/${id}/activate/`);
};

const multipleForm = async (query = {}) => {
  return await httpClient.get(`forms/multiple_form`, { params: query });
}

const ajaxTableForms = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/forms/?page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
    { params: query },
  );
};

export {
  getProjectsByStatus,
  getFormsByProject,
  getCategories,
  ajaxTableForms,
  retrieveForm,
  createForm,
  updateForm,
  deleteForm,
  deactivateForm,
  activateForm,
  multipleForm
};
